/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import * as moment from "moment";
import { withRouter } from "react-router-dom";
import { TableWrapper } from "../../../shared/layout";
import { templateStrings } from "../../../Constant";
import { vehicleWiseCollectionListAction } from "../../../redux/action-creators/collectionActionCreator";

class VehicleWiseCollectionList extends React.Component {
  constructor(props) {
    super(props);
    const m = moment(new Date());
    this.state = {
      showHeaderButton: true,
      pageNo: 0,
      rowsPerPage: 10,
      isUserAViewer: false,
      date: m,
      todaySelectable: true,
      backdrop: false,
      content: [],
      selected: [],
      sortBy: "",
    };
    this.getList = this.getList.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.onSortToggle = this.onSortToggle.bind(this);
  }

  componentDidMount() {
    this.getList();
  }

  componentDidUpdate(prevProps) {
    const {
      searchString, cityFilter, operatorFilter, selectedDateFilter, selectedOperation,
    } = this.props;
    if (
      (prevProps && prevProps.searchString !== searchString)
      || (prevProps && prevProps.cityFilter !== cityFilter)
      || (prevProps && prevProps.operatorFilter !== operatorFilter)
      || (prevProps && prevProps.selectedDateFilter !== selectedDateFilter)
      || (prevProps && prevProps.selectedOperation !== selectedOperation)
    ) {
      this.getList();
    }
  }

  // updateStateForRegion(regionId) {
  //   this.updateRightsForRegion(regionId);
  // }

  // updateComponentState(data) {
  //   this.setState({
  //     content: data || null,
  //   });
  //   if (this.mounted) {
  //   }
  // }

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.getList();
      }
    });
  };

  handleAction(vehicleDetails) {
    const { history } = this.props;
    history.push("/collection/details", vehicleDetails);
  }

  onSortToggle(value, key) {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.getList();
      },
    );
  }

  /**
   * API call to get devices.
   * @param pageNo current page number
   */
  getList() {
    const {
      fetchCollection, operatorFilter, searchString,
      selectedOperation, cityFilter, selectedDateFilter,
    } = this.props;
    const { pageNo, rowsPerPage, sortBy } = this.state;
    fetchCollection({
      pageNo,
      pageSize: rowsPerPage,
      searchString,
      operatorFilter,
      operationType: selectedOperation,
      cityFilter,
      dateFilter: selectedDateFilter,
      sortBy,
    });
  }

  render() {
    const {
      headerLoader, content, totalItems,
    } = this.props;
    const {
      selected, pageNo, rowsPerPage, sortBy,
    } = this.state;
    return (
      <div>
        <TableWrapper
          content={!headerLoader && content}
          selected={selected}
          pageNo={pageNo}
          uniqueKey="busNumber"
          rowsPerPage={rowsPerPage}
          count={totalItems}
          handleChange={this.handleChange}
          templateString={templateStrings.vehicleWise}
          selectionAllowed={false}
          handleAction={this.handleAction}
          onSortToggle={this.onSortToggle}
          sortBy={sortBy}
          tableContainerClassName="collection-table"
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.Collection
        && state.Collection.vehicleWiseCollection
        && state.Collection.vehicleWiseCollection.data)
      || [],
    totalItems:
      (state
        && state.Collection
        && state.Collection.vehicleWiseCollection
        && state.Collection.vehicleWiseCollection.totalItems)
      || 0,
    cityFilter: state.Cities.selectedCity,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    operatorFilter: state.Operators.selectedOperator,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    user: state.Auth.user,
    selectedOperation: state.OperationType.selectedOperationType,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchCollection: (params) => {
    dispatch(vehicleWiseCollectionListAction(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VehicleWiseCollectionList));
